import { render, staticRenderFns } from "./VerdeEsperanza.vue?vue&type=template&id=24c537ad&"
import script from "./VerdeEsperanza.vue?vue&type=script&lang=js&"
export * from "./VerdeEsperanza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports